import { createSlice } from "@reduxjs/toolkit";

const playQuestionsListSlice = createSlice({
  name: "questions",
  initialState: {
    questions: [],
  },
  reducers: {
    getQuestionsList: (state, action) => {
      state.questions = action.payload;
    },
  },
});

export const { getQuestionsList } = playQuestionsListSlice.actions;

export default playQuestionsListSlice.reducer;
